module.exports = "/_next/static/images/8316f84d8f69940bbd10f547bfe3e2c4-doggo-lg.jpg.webp";